//import CreateTrip from "../../pages/create-trip/oldcreatetrip";
import TripDetails from "../../pages/trip-details";
import CreateTripPage from "../../pages/create-trip";
export var TripManagement_Routes = [
    {
        PATH: "create",
        COMPONENT: CreateTripPage,
        isProtected: true,
    },
    {
        PATH: "edit/:tripId",
        COMPONENT: CreateTripPage,
        isProtected: true,
    },
    {
        PATH: ":tripId",
        COMPONENT: TripDetails,
        isProtected: false,
    },
];
